import { Menu, Bell, Search } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';

export function Header({ onMenuClick }) {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-30 h-16 bg-[#020617]/80 backdrop-blur-xl border-b border-slate-800 flex items-center justify-between px-4 lg:px-6">
      {/* Left side */}
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 hover:bg-slate-800 rounded-sm"
          data-testid="menu-toggle-btn"
        >
          <Menu className="w-5 h-5" />
        </button>
        
        {/* Search */}
        <div className="hidden md:flex items-center gap-2 px-3 py-2 bg-slate-900 border border-slate-800 rounded-sm w-64">
          <Search className="w-4 h-4 text-slate-500" />
          <input
            type="text"
            placeholder="Search..."
            className="bg-transparent text-sm text-slate-300 placeholder:text-slate-500 outline-none w-full"
            data-testid="header-search-input"
          />
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-4">
        {/* Notifications */}
        <button 
          className="relative p-2 hover:bg-slate-800 rounded-sm"
          data-testid="notifications-btn"
        >
          <Bell className="w-5 h-5 text-slate-400" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-green-500 rounded-full"></span>
        </button>

        {/* User info */}
        <div className="flex items-center gap-3">
          <Avatar className="w-8 h-8">
            <AvatarImage src="https://images.unsplash.com/photo-1704223523169-52feeed90365?crop=entropy&cs=srgb&fm=jpg&q=85&w=100" />
            <AvatarFallback className="bg-green-500 text-slate-900 font-bold">
              {user?.name?.charAt(0) || 'A'}
            </AvatarFallback>
          </Avatar>
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-white" data-testid="admin-name">
              {user?.name || 'Admin'}
            </p>
            <p className="text-xs text-slate-500">{user?.role || 'Administrator'}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
